<div class="flex justify-end gap-1 pr-[0.25em]">
  @if (showReportButton && params.data?.asset_recovery_id) {
    <a
      panButton
      [routerLink]="['/shared', 'asset-recovery-report', params.data.asset_recovery_id]"
      target="_blank"
      color="info"
      icon="description"
      matTooltip="AR Report"
    ></a>
  }
  @if (params.data?.review_id) {
    <a
      panButton
      [routerLink]="['/shared', 'investigation', params.data.review_id]"
      target="_blank"
      color="primary"
      icon="open_in_new"
      matTooltip="View Details"
    ></a>
  }
</div>
